module.exports = __webpack_public_path__ + "media/body-condition/normal-just-right-def48573.svg";